import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { ProgressBySection } from '../progress-by-section-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<ProgressBySection, unknown>[] = [
		buildColumn(util, 'Id', row => row.personId, { header: 'personId' }),
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId' }),
		buildColumn(util, 'Text', row => row.parentLevelName, { header: 'Module', group: { order: 1, dir: 'asc' }, hidden: true }),
		buildColumn(util, 'Text', row => row.levelName, { header: 'Section', group: { order: 2, dir: 'asc' }, hidden: true }),
		buildColumn(util, 'Text', row => row.personFullName, { header: 'Name' }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture', renderCellClasses: row => row.isVentureDroppedOut ? ['grid-cell-strikethrough', 'grid-cell-red-text'] : [] }),
		buildColumn(util, 'Text', row => `${row.completedActivitiesCount} of ${row.totalRequiredActivitiesCount} Activities completed`, { header: 'Progress' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.dueDateUTC), { header: 'Due Date' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.startUTC), { header: 'Started Date' }),
		buildColumn(util, 'DateTime', row => row.completedUTC ? util.date.fromUTC(row.completedUTC) : undefined, { header: 'Completed Date' }),
	];


	return columns;

}